import { styled } from '@mui/material/styles'
import Box from '@mui/material/Box'
import Checkbox from '@mui/material/Checkbox'
import Typography from '@mui/material/Typography'

// Container for the "Select All" section
export const SelectAllWrapper = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  marginLeft: '16px',
  marginBottom: '15px',
})

// Customized checkbox with primary theme color
export const StyledCheckbox = styled(Checkbox)(({ theme }) => ({
  color: theme.palette.primary.main,
}))

// Label styling for "Select All" text
export const SelectAllLabel = styled(Typography)({
  fontSize: '18px',
  fontWeight: 'bold',
})
